export const enum StatsTealiumDataLayerEventTypeEnum {
  /**
   * Click event type
   */
  click = 'click',
}
